import { PaginationPage, PaginationPageLabel } from './pagination';

const MODEL_FIELDS = ['number', 'size', 'totalElements'];
const PAGE_RANGE = 6;

/**
 * Bietet statische Methoden bezüglich die Page Modifizierung.
 */
export class PaginationUtils {
    /**
     * Erweitert (extend) alle gegebene Pages.
     */
    static clone(...args: PageCloner[]) {
        const params = args.reduce((res, cur) => {
            MODEL_FIELDS.forEach(field => {
                res[field] = cur[field] !== undefined ? cur[field] : res[field];
            });
            return res;
        }, {});

        return new PaginationPage(params.number, params.totalElements, params.size);
    }

    /**
     * Generiert eine Liste, die weiter im PaginationComponent benutzt wird
     */
    static getPageLabels(currentPage: number, itemsPerPage: number, totalItems: number): PaginationPageLabel[] {
        const pages = [];
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        const halfWay = Math.ceil(PAGE_RANGE / 2);

        const isStart = currentPage <= halfWay;
        const isEnd = totalPages - halfWay <= currentPage;
        const isMiddle = !isStart && !isEnd;

        const ellipsesNeeded = PAGE_RANGE < totalPages;
        let i = 1;

        while (i <= totalPages && i <= PAGE_RANGE) {
            let label;
            const pageNumber = calculatePageNumber(i, currentPage, PAGE_RANGE, totalPages);
            const openingEllipsesNeeded = (i === 2 && (isMiddle || isEnd));
            const closingEllipsesNeeded = (i === PAGE_RANGE - 1 && (isMiddle || isStart));
            if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                label = '...';
            } else {
                label = pageNumber;
            }
            pages.push({
                label: label,
                value: pageNumber
            });
            i++;
        }
        return pages;

        function calculatePageNumber(i: number, currentPage: number, PAGE_RANGE: number, totalPages: number) {
            const halfWay = Math.ceil(PAGE_RANGE / 2);
            if (i === PAGE_RANGE) {
                return totalPages;
            }
            if (i === 0) {
                return i;
            }

            if (PAGE_RANGE < totalPages) {
                if (totalPages - halfWay < currentPage) {
                    return totalPages - PAGE_RANGE + i;
                }
                if (halfWay < currentPage) {
                    return currentPage - halfWay + i;
                }
                return i;
            }

            return i;
        }
    }
}

export class PageCloner {
    size?: number;
    number?: number;
    totalElements?: number;
}
